"use strict"

/**
 * Foodstand React Native App
 */
import React from "react"

import ReactNative from "react-native"
import { connect } from "react-redux"
import { colors } from "app/lib/styles"
import dataStore from "app/data/dataStore"
import handleOpenURL from "app/lib/handleOpenURL"
import PropTypes from "prop-types"

import PushNotificationHandler from "app/components/PushNotificationHandler"

import MainTabs from "app/navigators/MainTabs"
import { addListener } from "app/lib/redux"
import { addNavigationHelpers } from "react-navigation"
import { navigateTo, popToTop, switchTab } from "app/actions/app"

import MemberSearch from "app/views/MemberSearch"
import Feed from "app/views/Feed"
import CheckIn from "app/views/CheckIn"
import MyChallenge from "app/views/MyChallenge"
import Buddies from "app/views/Buddies"
import User from "app/views/User"
import Onboarding from "app/views/Onboarding"
import NewPost from "app/views/NewPost"
import WelcomeInfo from "app/views/Feed/components/WelcomeInfo"
import InviteFriends from "app/views/InviteFriends"
import KeyboardSubscription from "app/lib/KeyboardSubscription"
import KeyboardSpacer from "app/components/KeyboardSpacer"

import FSModal from "app/components/FSModal"
import ModalManager from "app/lib/ModalManager"

import Loading from "app/components/Loading"
import LoadingOverlay from "app/components/LoadingOverlay"
import Linking from "app/components/Linking"

import ChallengeTodayOrTomorrowPrompt from "app/components/ChallengeTodayOrTomorrowPrompt"

import styles from "./styles"

import { bootstrapApp, goBack } from "app/actions/app"

import { promptToClose } from "app/actions/newPost"
import DeviceEventEmitter from "app/lib/DeviceEventEmitter"

import { setupLatestSubscriptionUpdater } from "app/actions/challenges"

import {
  initiateNewChallengeSubscription,
} from "app/actions/challenges"

const {
  AppRegistry,
  StyleSheet,
  View,
  Text,
  InteractionManager,
  Platform,
  SafeAreaView,
  BackHandler,
} = ReactNative

class AppContent extends React.Component {
  state = { user: null }
  lastDeepLink = null

  componentWillReceiveProps(newProps) {
    var user = dataStore.get("user", this.props.app.currentUserId)
    if (this.state.user !== user) {
      this.setState({
        user: user,
      })

      //Diet ID Hack.  Check if user is not subscribed to initial challenge options and if not
      //launch them into join flow
      if (this.props.initialChallengeId && this.props.initialChallengeDifficultyId && newProps.challenges.latestSubscriptionInitialized) {
        let subId = newProps.challenges.latestChallengeSubscriptionId
        let sub = subId ? dataStore.get("challenge_subscription", subId) : null
        if (!sub || sub.challenge_id !== this.props.initialChallengeId || sub.challenge_difficulty_id !== this.props.initialChallengeDifficultyId) {
          //this.props.dispatch(initiateNewChallengeSubscription(this.props.initialChallengeId, this.props.initialChallengeDifficultyId))
          this.props.dispatch(switchTab("mychallenge"))
          this.props.dispatch(navigateTo("challenge_selector", {
            title: "Join Challenge",
            challenge_id: this.props.initialChallengeId,
            challenge_difficulty_id: this.props.initialChallengeDifficultyId,
          }))
        }
      }
    }
    if (!this.props.app.currentUserId && newProps.app.currentUserId) {
      setTimeout(() => {
        DeviceEventEmitter.emit("fs-sign-in")
      })
    }
  }

  subscribeToKeyboardVisibility() {
    this.visibleListener = KeyboardSubscription.onShow(() => {
      this.setState({ keyboardVisible: true })
    })
    this.hiddenListener = KeyboardSubscription.onHide(() => {
      this.setState({ keyboardVisible: false })
    })
  }

  componentWillUnmount() {
    if (this.visibleListener) {
      this.visibleListener.remove()
    }
    if (this.hiddenListener) {
      this.hiddenListener.remove()
    }
  }

  userIsSignedOut = () => {
    return (
      this.props.app.currentUserId === undefined ||
      !this.props.app.currentUserId ||
      this.props.onboarding.signup.creatingUser ||
      this.props.onboarding.signup.justCreatedUser
    )
  }

  setupDeepLinkHandler() {
    Linking.addEventListener("url", event => {
      handleOpenURL(event.url, this.props.dispatch)
    })

    var url = Linking.getInitialURL()
      .then(url => {
        if (url && url.indexOf("http") === 0 && url.indexOf("#") > 0) {
          // This means we're on web
          url = "foodstand://" + url.split("#")[1]
        }
        //url = 'foodstand://users/511';
        //url = 'foodstand://post/11426';
        //url = 'foodstand://location/50';
        //url = 'foodstand://invite-friends';
        //url = 'foodstand://buddies';
        //url = 'foodstand://buddies/requests';
        //url = 'foodstand://mychallenge';
        //url = 'foodstand://profile';
        //url = 'foodstand://checkin';
        //url = 'foodstand://notifications';
        //url = "foodstand://direct-messages/new"
        //url = 'foodstand://direct-messages/new?recipient_id=91'

        if (url && url !== this.lastDeepLink) {
          this.lastDeepLink = url
          InteractionManager.runAfterInteractions(() => {
            handleOpenURL(url, this.props.dispatch)
          })
        }
      })
      .catch(() => {
        fsConsole.warn("FoodstandApp: Failed to get initial url")
      })
  }

  componentDidMount() {
    this.subscribeToKeyboardVisibility()

    BackHandler.addEventListener("hardwareBackPress", () => {
      const { dispatch, navigation, nav } = this.props
      if (!nav) {
        return false
      }
      dispatch(goBack())
      return true
    })
  }

  componentWillMount() {
    // Initialize:
    window.dispatch = this.props.dispatch
    this.props.dispatch(bootstrapApp())
    this.props.dispatch(setupLatestSubscriptionUpdater())
    this.setupDeepLinkHandler()
  }

  renderLoading = () => (
    <View style={[styles.container, styles.loadingContainer]}>
      <Loading loaded={this.props.app.loaded} style={styles.loading} />
    </View>
  )

  renderSignedIn = user => (
    <View style={styles.appWrap}>
      <MainTabs
        navigation={addNavigationHelpers({
          dispatch: this.props.dispatch,
          state: this.props.nav,
          addListener,
        })}
      />

      <ChallengeTodayOrTomorrowPrompt
        dispatch={this.props.dispatch}
        currentUserId={this.props.app.currentUserId}
        visible={this.props.challenges.pendingChallengeSubscription !== null}
        challenges={this.props.challenges}
      />

      {this.renderNewPostModal(user)}

      {Platform.OS === "ios" ? <KeyboardSpacer topSpacing={-44} /> : null}

      <PushNotificationHandler />
    </View>
  )

  closeNewPost = () => {
    this.props.dispatch(promptToClose())
    return true
  }

  static childContextTypes = {
    navContext: PropTypes.string,
  }

  getChildContext() {
    if (!this.props.app.currentUserId || this.props.onboarding.signup.creatingUser) {
      return { navContext: "signed-out" }
    } else {
      return { navContext: this.props.app.selectedTab }
    }
  }

  renderNewPostModal = user => (
    <FSModal
      animation="slideInUp"
      closeAnimation="bounceOutDown"
      duration={350}
      visible={this.props.newPost.base.active}
      context={this.props.app.selectedTab}
      onRequestClose={this.closeNewPost}
    >
      <NewPost />
    </FSModal>
  )

  renderSignedOut = () => (
    <View style={{ flex: 1 }}>
      <Onboarding />
      <ChallengeTodayOrTomorrowPrompt
        dispatch={this.props.dispatch}
        visible={this.props.challenges.pendingChallengeSubscription !== null}
        challenges={this.props.challenges}
      />
    </View>
  )

  render() {
    if (!this.props.app.loaded) {
      return this.renderLoading()
    } else if (this.userIsSignedOut()) {
      //New user, or signed out user
      return this.renderSignedOut()
    } else {
      var user = dataStore.get("user", this.props.app.currentUserId)
      return this.renderSignedIn(user)
    }
  }
}
AppContent = connect(mapStateToProps)(AppContent)

class AppModal extends React.Component {
  render() {
    var user = dataStore.get("user", this.props.app.currentUserId)
    return (
      <SafeAreaView
        style={styles.modal}
        {...this.props.contentRenderProps}
        pointerEvents="box-none"
      >
        <View style={{ flex: 1 }}>
          {this.props.contentRenderFn.bind(this.props.contentRenderProps)()}
        </View>
        {Platform.OS === "ios" ? <KeyboardSpacer disableAndroid /> : null}
      </SafeAreaView>
    )
  }
}
AppModal = connect(mapStateToProps)(AppModal)

class FoodstandApp extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalShowing: false,
    }
  }

  componentDidMount() {
    ModalManager.rootModalOpener = this.openModal
    ModalManager.rootModalRefresher = this.refreshModal
    ModalManager.rootModalCloser = this.closeModal
  }

  refreshModal = (renderFn, childProps) => {
    this.setState({
      modalShowing: true,
      modalRenderFn: renderFn,
      modalRenderProps: childProps,
    })
  }

  openModal = (renderFn, childProps) => {
    this.setState({
      modalShowing: true,
      modalRenderFn: renderFn,
      modalRenderProps: childProps,
    })

    setTimeout(() => {
      //Have to wait for re-render before ref will be available
      var cont = this.refs["app-modal-container"]
      if (
        cont &&
        cont.refs &&
        cont.refs.wrappedInstance &&
        cont.refs.wrappedInstance.refs
      ) {
        ModalManager.refs = cont.refs.wrappedInstance.refs
      }
    })
  }

  closeModal = renderFn => {
    this.setState({
      modalShowing: false,
      modalRenderFn: null,
    })
    ModalManager.refs = null
  }

  renderScene = (route, nav) => {
    var Component = route.component

    return <Component {...route.passProps} />
  }

  render() {
    return (
      <View style={{ flex: 1 }}>
        <AppContent {...this.props} />
        {this.state.modalShowing && (
          <AppModal
            ref="app-modal-container"
            contentRenderFn={this.state.modalRenderFn}
            contentRenderProps={this.state.modalRenderProps}
          />
        )}
        <LoadingOverlay isLoading={this.props.challenges.subscribingToChallenge} />
      </View>
    )
  }
}

function mapStateToProps(state) {
  return Object.assign(
    {},
    {
      app: state.app,
      onboarding: state.onboarding,
      nav: state.nav,
      challenges: state.challenges,
      newPost: state.newPost,
    }
  )
}

export default connect(mapStateToProps)(FoodstandApp)
